export default "__VITE_ASSET__ca978e97__"